/* eslint-disable */
/// This file is auto generated - do not edit manually
export * as NoHits from './trans-website-booking-consultationlist-nohits';
export * as ContentHeader from './trans-website-booking-consultationlist-contentheader';
export * as Tooltips from './trans-website-booking-consultationlist-tooltips';
export * as ConsultationItem from './trans-website-booking-consultationlist-consultationitem';
export * as ListStoresView from './trans-website-booking-consultationlist-liststoresview';
export * as TypeFilter from './trans-website-booking-consultationlist-typefilter';
export * as VirtualButtonGroup from './trans-website-booking-consultationlist-virtualbuttongroup';

export const LoadMoreButton = 'Website.Booking.ConsultationList.LoadMoreButton';
export const EventsHeadline = 'Website.Booking.ConsultationList.EventsHeadline';
export const ChooseStore = 'Website.Booking.ConsultationList.ChooseStore';
export const UsePosition = 'Website.Booking.ConsultationList.UsePosition';
export const CategoriesFilterPlaceholder = 'Website.Booking.ConsultationList.CategoriesFilterPlaceholder';
export const BrandsFilterPlaceholder = 'Website.Booking.ConsultationList.BrandsFilterPlaceholder';
export const AllCategoriesFilter = 'Website.Booking.ConsultationList.AllCategoriesFilter';
export const AllBrandsFilter = 'Website.Booking.ConsultationList.AllBrandsFilter';
export const CategoriesFilterQuickViewHeadline = 'Website.Booking.ConsultationList.CategoriesFilterQuickViewHeadline';
export const BrandsFilterQuickViewHeadline = 'Website.Booking.ConsultationList.BrandsFilterQuickViewHeadline';
export const ResetAllFilters = 'Website.Booking.ConsultationList.ResetAllFilters';
export const StorePageViewAll = 'Website.Booking.ConsultationList.StorePageViewAll';
